import React from "react";
import classNames from "classnames";
import styles from "./InstantTournaments.module.scss";
import playerPersonBg from "./assets/player-item-photo-bg.png";
import emptyAva from "./assets/empty-ava.png";
import noResult from "./assets/no-results.png";
import { ProfileImage } from "../../ProfileImage";
import { useUserId } from "../../UserProvider";
import { ButtonWithSound } from "../../AudioProvider";
import { useTranslation } from "react-i18next";
import { TournamentTeam } from "../../../graphql/generated";
import { useHistory, useParams } from "react-router-dom";

const TournamentPair = ({
  tableId,
  team,
  toBeDecided,
  isWinner,
  isOneVSOne,
  isMatchCancelled,
}: {
  tableId?: string;
  team?: TournamentTeam;
  toBeDecided?: boolean;
  isWinner?: boolean | null;
  isOneVSOne: boolean;
  isMatchCancelled: boolean;
}) => {
  const { t } = useTranslation();
  const id = useUserId();
  const { push } = useHistory();
  const { sectionId } = useParams<{
    sectionId: string;
  }>();

  const isMyPair = team?.players?.[0]
    ? team?.players?.some((player) => player?.id === id)
    : false;
  const isWinnerKnown = typeof isWinner === "boolean";

  if (isMatchCancelled) {
    return (
      <div className={classNames(styles.pair)}>
        <div
          className={classNames(
            "flex justify-between items-center rounded-md",
            styles.otherPairLose
          )}
          style={{
            padding: "6px 8px",
            boxShadow: "unset",
          }}
        >
          <div className="flex flex-col w-full" style={{ gap: "5px" }}>
            <div className="flex items-center gap-2">
              <img src={noResult} alt="" style={{ width: "2.5rem" }} />
              <div className="flex flex-col gap-1">
                <span className="leading-6 text-sm">
                  {t("instant_tournament.no_result")}
                </span>
                <span
                  className="leading-6 text-sm"
                  style={{ color: "#727587" }}
                >
                  {t("instant_tournament.match_cancelled")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={classNames(styles.pair, {
        [styles.myPair]: isMyPair,
        [styles.myPairWin]: isWinnerKnown && isWinner,
        [styles.myPairLose]: isWinnerKnown && !isWinner,
        [styles.toBeDecidedPair]: toBeDecided,
      })}
    >
      <div
        className={classNames("flex justify-between items-center rounded-md", {
          [styles.myPairBg]: isMyPair,
          [styles.otherPair]: !isMyPair && !isWinner,
          [styles.otherPairWin]: !isMyPair && isWinnerKnown && isWinner,
          [styles.otherPairLose]: !isMyPair && isWinnerKnown && !isWinner,
          [styles.otherPairLose]: !isMyPair && isMatchCancelled,
        })}
        style={{
          padding: "6px 8px",
          boxShadow:
            isMyPair && !isWinnerKnown ? "0px 0px 10px 0px #3AC0FE" : "unset",
        }}
      >
        <div className="flex flex-col w-full" style={{ gap: "5px" }}>
          <div className="flex items-center gap-2">
            {toBeDecided ? (
              <>
                <img
                  src={emptyAva}
                  style={{ width: "2rem", height: "2rem" }}
                  alt="empty"
                />
                <span className="text-sm" style={{ color: "#727587" }}>
                  {t("instant_tournament.to_be_decided")}
                </span>
              </>
            ) : (
              <>
                <div
                  className={classNames(
                    "flex items-center justify-center",
                    styles.playerRoundPhoto
                  )}
                  style={{
                    backgroundImage: `url(${playerPersonBg})`,
                    backgroundSize: "cover",
                  }}
                >
                  <ProfileImage
                    className="bg-gray-400 border rounded-full"
                    id={team?.players?.[0]?.id || ""}
                    name={team?.players?.[0]?.name || ""}
                  />
                </div>
                <span className="leading-6 text-sm">
                  {team?.players?.[0]?.name || ""}
                </span>
              </>
            )}
          </div>
          {!isOneVSOne && (
            <div className="flex items-center gap-2">
              {toBeDecided ? (
                <>
                  <img
                    src={emptyAva}
                    style={{ width: "2rem", height: "2rem" }}
                    alt="empty"
                  />
                  <span className="text-sm" style={{ color: "#727587" }}>
                    {t("instant_tournament.to_be_decided")}
                  </span>
                </>
              ) : (
                <>
                  <div
                    className={classNames(
                      "flex items-center justify-center",
                      styles.playerRoundPhoto
                    )}
                    style={{
                      backgroundImage: `url(${playerPersonBg})`,
                      backgroundSize: "cover",
                    }}
                  >
                    <ProfileImage
                      className="bg-gray-400 border rounded-full"
                      id={team?.players?.[1]?.id || ""}
                      name={team?.players?.[1]?.name || ""}
                    />
                  </div>
                  <span className="leading-6 text-sm">
                    {team?.players?.[1]?.name || ""}
                  </span>
                </>
              )}
            </div>
          )}
        </div>
        {isMyPair && !isWinnerKnown && (
          <ButtonWithSound
            onClick={() => push(`/area/${sectionId}/${tableId}`)}
            className="btn btn-green-500 text-white rounded-lg px-4 py-2 leading-none text-sm"
          >
            {t("play")}
          </ButtonWithSound>
        )}
      </div>
    </div>
  );
};

export default TournamentPair;
